// extracted by mini-css-extract-plugin
export default {"btnpwd":"ea422a3fd4"};